import { useEffect } from "react";

export function useInView({ defaultOnce = true, ...observerOptions } = {}) {
    useEffect(() => {
        const elements = document.querySelectorAll("[data-animation]");
        if (!elements.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const el = entry.target;
                    let config = { once: defaultOnce };

                    const attr = el.getAttribute("data-animation");
                    if (attr && attr !== "") {
                        try {
                            config = { ...config, ...JSON.parse(attr) };
                        } catch {
                            // si no es JSON, usamos defaultOnce
                        }
                    }

                    const { once, delay = 0, class: animationClass = "animate" } = config;

                    if (entry.isIntersecting) {
                        if (delay) el.style.transitionDelay = `${delay}s`;
                        el.classList.add(animationClass);
                        if (once) observer.unobserve(el);
                    } else if (!once) {
                        el.classList.remove(animationClass);
                    }
                });
            },
            { root: null, rootMargin: "0px", threshold: 0.05, ...observerOptions }
        );

        elements.forEach((el) => observer.observe(el));
        return () => observer.disconnect(); //Desconectamos todos los observe cuando el componente es desmontado
    }, [defaultOnce, observerOptions]);
}
